// extracted by mini-css-extract-plugin
export default {"statusImage":"StatusDropzone_statusImage__O-BAW","statusImageWrapper":"StatusDropzone_statusImageWrapper__YCfIu","small":"StatusDropzone_small__aKQpZ"};